export default function phoneMask(value) {
  return '+1 (###) ###-####';
}
